import { Company } from "../company-service";
import { Vehicle } from "../vehicle-service";

export interface ProductConfig {
  softwareVersion: string;
  verticalTreshold: number;
  horizontalTreshold: number;
  hasShockDetection: boolean;
}

export interface PendingRenewalRequest {
  id: string;
  requestedDuration: string;
  currentEndDate: string | null;
}

export interface Product {
  id: string;
  serialNumber: string;
  status: string;
  createdAt: string;
  vehicleId: string;
  unregisteredAt: string;
  registeredAt: string;
  vehicle: Vehicle;
  company: Company;
  subscriptionEndDate: string | null;
  hasPendingRenewal: boolean;
  pendingRenewalRequest: PendingRenewalRequest | null;
}

export enum ProductStatus {
  DELIVERED = "DELIVERED",
  VALIDATION_REQUIRED = "VALIDATION REQUIRED",
  UNREGISTERED = "UNREGISTERED",
  REGISTERED = "REGISTERED",
}

export enum ProductSubscription {
  ACTIVE = "ACTIVE",
  EXPIRING_SOON = "EXPIRING SOON",
  EXPIRED = "EXPIRED",
  PENDING_RENEWAL = "PENDING RENEWAL",
}
